export default {
    ownerAccount: `บัญชีเจ้าของ`,
    updateAccount: 'อัปเดตบัญชี',
    updateProfile: `อัปเดตโปรไฟล์`,
    locations: ` ที่ตั้ง`,
    changePassword: `เปลี่ยนรหัสผ่าน`,
    logout: `ออกจากระบบ`
}